export default "__VITE_ASSET__3ceb3266__"